<template>
	<div>
		<div class="buy-car d-flex wrap mb-2">
			<div class=" d-flex flex-65 wrap">
				<component-sale
					v-if="hideComponents"
					:quantity="quantityResume"
				/>
				<div
					class="d-flex mb-4 mt-4 section-title-container wrap txt-center align-center"
					v-if="isPayment"
				>
					<products-buy-car-svg />
					<h2
						class="uppercase bold section-title"
						:style="`color:${globalColors.primary}`"
					>Productos</h2>
				</div>
				<buy-table class="buy-table flex-95"/>
				<router-view class="flex-95"></router-view>
			</div>
			<purchase-summary
				class="flex-15"
				@go-back="back"
			/>
		</div>
		<app-footer/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import productsBuyCarSvg from '@/components/svg-components/productBuyCar';

function mounted() {
	const { pageTitle, pageDescription } = this.$route.meta;
	this.setPageTitle(pageTitle);
	this.updateDescriptionTag(pageDescription);
}

function carEmpty() {
	this.$store.commit('UPDATE_PRODUCTS_SELECTED');
}

function setTaxes(taxes) {
	const newTaxes = [];
	if (!taxes && taxes.length === 0) {
		newTaxes[0] = {
			code: '01',
			codeTable: 'TABLE17',
			codePercentage: '01',
			flagSales: true,
			flagPurchases: false,
		};
	} else {
		const tax = taxes[0];
		newTaxes[0] = {
			code: tax.code,
			codeTable: tax.codeTable,
			codePercentage: tax.codePercentage,
			flagSales: Boolean(tax.flagSales),
			flagPurchases: Boolean(tax.flagPurchases),
		};
	}
	return newTaxes;
}

function getDetails(products) {
	return products.map((p) => {
		const { taxes } = p;
		const newTaxes = this.setTaxes(taxes);
		const newP = {
			alternateCode: p.alternateCode,
			brandId: p.warehouseProduct.brandId,
			brandName: p.warehouseProduct.brand.name,
			categoryId: p.categoryId,
			categoryName: p.category.name,
			codeTaxes: taxes[0].code,
			description: p.description,
			discount: p.discount || 0,
			discountPercentage: p.discountPercentage || 0,
			product: { taxes: [...newTaxes], type: p.typeInfo.id, id: p.id },
			productCode: p.code,
			productId: p.id,
			productImage: p.urlImage,
			productName: p.name,
			quantity: p.quantity,
			salePrice: p.priceDiscount,
			stockQuantity: p.stock,
			taxes: newTaxes,
			unit: p.unit,
			unitCode: p.unit.code,
			unitConversion: 1,
			unitId: p.unitId,
			unitName: p.unit.name,
			unitQuantity: p.quantity,
			warehouseId: this.warehouse.id,
			warehouseName: this.warehouse.name,
		};
		return newP;
	});
}

function buildBody() {
	const body = {
		deliveryAddress: this.$store.state.deliveryAddress,
		details: this.getDetails(this.$store.state.productsSelected),
		flagPickUp: this.$store.state.flagPickUp,
		responsiblePickUp: this.$store.state.responsibleData,
		warehouseId: this.warehouse.id,
		warehouseName: this.warehouse.name,
		warehouseAddress: this.warehouse.address,
		commerceCode: process.env.COMMERCE_CODE,
	};
	return body;
}

async function makeOrder() {
	const { token } = this.$store.state;
	if (token) {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const body = this.buildBody();
		const { data: order } = await this.$httpJapi.post('orders', body, { headers });
		this.$store.commit('SAVE_NEW_ORDER', order);
		this.$message({
			message: 'Pedido realizado con éxito!',
			showClose: true,
			type: 'success',
		});
		this.$router.push({ name: 'order-summary' });
		this.$store.commit('UPDATE_PRODUCTS_SELECTED');
	} else {
		this.$message({
			message: 'Debe iniciar sesión para realizar el pedido',
			showClose: true,
			type: 'error',
		});
	}
}

function updateQuantityResume(quantity) {
	this.quantityResume = quantity;
}

function quantityResume() {
	const resume = this.rows.length;
	return resume;
}

function back() {
	this.showPickUp = false;
}

function hideComponents() {
	return !this.$route.path.includes('payment');
}

function isPayment() {
	return this.$route.name === 'payment';
}

function data() {
	return {
		rows: [],
		showPickUp: false,
	};
}

export default {
	name: 'BuyCar',
	components: {
		appFooter: () => import('@/sections/Footer'),
		buyTable: () => import('@/components/buyTable'),
		componentSale: () => import('@/components/componentSale'),
		pickUp: () => import('@/components/pickUp'),
		productsBuyCarSvg,
		purchaseSummary: () => import('@/components/purchaseSummary'),
		warehouseModal: () => import('@/components/warehousePickUpModal'),
	},
	computed: {
		...mapGetters([
			'productsSelected',
			'warehouse',
		]),
		hideComponents,
		isPayment,
		quantityResume,
	},
	data,
	methods: {
		back,
		carEmpty,
		buildBody,
		getDetails,
		makeOrder,
		setTaxes,
		updateQuantityResume,
	},
	mounted,
};
</script>

<style lang="scss" scoped>

.buy-car {
	padding: 0 5.1rem;

	@media (max-width: 425px) {
		padding: 0;
		
	}
}

.buy-table {
	margin: 0 1rem;

	@media (max-width: 500px) {
		margin: auto;
	}
}
</style>




// WEBPACK FOOTER //
// BuyCar.vue?5e0fb86e